// TODO: refactor so packslist isn't in home
import { withClassNames } from '~/styles/utils'
import s from './packs.module.scss'
import { PageTransitions } from '../components/Animations'
import { ProdNfts } from '../components/Prod'
import { MikeMoNfts } from '../components/MikeMo'
import { ToreyNfts } from '../components/Series3/ToreyNfts'
import { ToreyBoxes } from '../components/Series3/ToreyBoxes'
import { ProductColumnsTwo } from '../components/Lock/ProductColumnsTwo'
import { AndyPacks } from '../components/Lock/AndyPacks'
const cx = withClassNames(s)

export const Packs = () => {
  return (
    <PageTransitions>
      <div className={cx('packs-page-container')}>
        <AndyPacks />
        <h1>Yuto Horigome Packs</h1>
        <ProductColumnsTwo />
        <h1>Series 2 Packs</h1>
        <ProdNfts />
        <br></br>
        <br></br>
        <hr></hr>
        <h1>Series 3 Packs</h1>
        <br></br>
        <ToreyNfts />
        <br></br>
        <h1>Series 3 Boxes</h1>
        <ToreyBoxes />
        <h1>Series 1 Packs</h1>
        <MikeMoNfts />
      </div>
    </PageTransitions>
  )
}